var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCancleRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M14.9477 4.63367C15.1715 4.85741 15.1902 5.20853 15.0038 5.45354L14.9479 5.51755L10.6764 9.79046L14.9504 14.0644C15.1944 14.3085 15.1944 14.7042 14.9504 14.9483C14.7266 15.172 14.3755 15.1906 14.1305 15.0042L14.0665 14.9483L9.79256 10.6743L5.52218 14.9471C5.27815 15.1913 4.88238 15.1914 4.6383 14.9473C4.41456 14.7236 4.3958 14.3724 4.5822 14.1274L4.63812 14.0634L8.90867 9.79046L4.63716 5.51894C4.39308 5.27487 4.39308 4.87914 4.63716 4.63506C4.8609 4.41132 5.21206 4.39268 5.45704 4.57913L5.52104 4.63506L9.79256 8.90657L14.0639 4.63385C14.3079 4.38972 14.7037 4.38959 14.9477 4.63367Z",
    fill: "#D64C4C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancleRed);
export default __webpack_public_path__ + "static/media/icon-cancle-red.680226edc328e0303c8c428f060c1c01.svg";
export { ForwardRef as ReactComponent };